import { DocumentRequiredFields } from './types';

import { mapRequiredFieldToApi } from './utils';

import graph from '../graph';
import io from '../io';
import { prepareSignSessionOptions } from '../sign-session';

export async function getDocumentRequiredFields(
    companyId: string,
): Promise<DocumentRequiredFields[]> {
    const data = await graph.get(
        `
        query {
            allDocumentRequiredFields${graph.formatArguments({
                companies_ids: [companyId],
            })}{
                id
                documentCategory
                isNameRequired
                isTypeRequired
                isNumberRequired
                isDateRequired
                isAmountRequired
            }
      }`,
        '',
        prepareSignSessionOptions(),
    );
    return data.allDocumentRequiredFields;
}

export function createDocumentRequiredFields(
    data: Omit<DocumentRequiredFields, 'id'>,
) {
    return io.post(
        '/internal-api/documents/required-field',
        mapRequiredFieldToApi(data),
    );
}

export function patchDocumentRequiredFields(data: DocumentRequiredFields) {
    return io.patch(`/internal-api/documents/required-field/${data.id}`, {
        ...mapRequiredFieldToApi(data),
        // undefined does not serialize to JSON and gets deleted
        id: undefined,
    });
}

export function deleteDocumentRequiredFields(id: string) {
    return io.delete(`/internal-api/documents/required-field/${id}`);
}
